module.exports = __webpack_public_path__ + "img/14.fc4be922.gif";